/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'
import { TableRow, TableCell, IconButton } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { palette } from 'styles/colors'
import MenuOptions from 'components/MenuOptions'
import CallIcon from '@material-ui/icons/Call'
import AccountCircle from '@material-ui/icons/AccountCircle'
import LocalHospital from '@material-ui/icons/LocalHospital'
import Button from 'components/Button'
import { _downloadReception } from 'api/http/receptions'
import moment from 'moment'

const Reciptions = ({
  classes,
  reciptions,
  openMedcard,
  openReviews,
  openComplaints,
  openRefferal,
  openMark,
  openDeclineReception,
  openChangeTime,
  openConnected,
  openRepeated,
  openFirstRepeated,
  openDecision,
  openCoordinator
}) => {
  const formatDate = (date) => {
    let receptionDate =
      date.split('-')[2] + '.' + date.split('-')[1] + '.' + date.split('-')[0]
    return receptionDate
  }

  const formatTime = (time) => {
    let receptionTime = time.split(':')[0] + ':' + time.split(':')[1]
    return receptionTime
  }

  const handleDownload = async (reception) => {
    const { data } = await _downloadReception({ id: reception.id })
    let a = document.createElement('a')
    a.href = data.redirectTo
    a.download = `${reception.id}_reception_video.mp4`
    a.target = '_blank'
    a.click()
  }

  const medcardStatus = (reception) => {
    if (reception.isCardFilled) {
      return (
        <span style={{ color: palette.status.done }}>Медкарта заполнена</span>
      )
    }

    switch (reception.quality) {
      case 'duty':
        return 'Дежурный'
      case 'unfinished':
        return 'Предстоящий'

      default:
        return (
          <span style={{ color: palette.status.failed }}>
            Медкарта не заполнена
          </span>
        )
    }
  }

  const specialistDecision = (decision) => {
    if (decision === 'confirmed') {
      return 'Подтверждён'
    }
    if (decision === 'time_changed') {
      return 'Перенесён'
    }
    if (decision === 'waiting') {
      return 'Ожидает подтверждения'
    }
    if (decision === 'rejected') {
      return 'Отклонен'
    }
  }

  return reciptions.map((reciption) => {
    const [showPhone, setShowPhone] = useState(false)
    // 0 => fullName, 1 => phone, 2 => speciality
    const [doctorViewMode, setDoctorViewMode] = useState(0)

    const [showComplaints, setShowComplaints] = useState(false)

    /** Специальность приходит объектом `speciality` на корне приёма; раньше — у specialist / specialities[] */
    const getReceptionSpecialityText = (reciption) => {
      const root = reciption?.speciality
      if (root?.jobTitle) return root.jobTitle
      if (root?.title) return root.title

      const specialist = reciption?.specialist
      const nested = specialist?.speciality
      if (nested?.jobTitle) return nested.jobTitle
      if (nested?.title) return nested.title

      const firstSpeciality = specialist?.specialities?.[0]
      if (firstSpeciality?.title) return firstSpeciality.title
      if (firstSpeciality?.jobTitle) return firstSpeciality.jobTitle

      return ''
    }

    return (
      <TableRow key={reciption.id}>
        <TableCell
          style={{ width: '20px', borderColor: palette.black, height: '40px' }}
          align="center"
        >
          {formatDate(reciption.receptionDate)}
        </TableCell>
        <TableCell
          style={{ width: '20px', borderColor: palette.black }}
          align="center"
        >
          {formatTime(reciption.receptionTime)}
        </TableCell>
        <TableCell
          style={{ width: '30px', borderColor: palette.black }}
          align="center"
        >
          <IconButton
            aria-label="delete"
            onClick={() =>
              setDoctorViewMode((prev) => (prev === 2 ? 0 : prev + 1))
            }
          >
            {doctorViewMode === 0 ? (
              <CallIcon />
            ) : doctorViewMode === 1 ? (
              <AccountCircle />
            ) : (
              <LocalHospital />
            )}
          </IconButton>
        </TableCell>
        <TableCell
          style={{ width: '50px', borderColor: palette.black }}
          align="center"
        >
          {doctorViewMode === 1
            ? '+' + reciption.specialist.phone
            : doctorViewMode === 2
              ? getReceptionSpecialityText(reciption) || '-'
              : reciption.specialist.fullName}
        </TableCell>
        <TableCell
          style={{ width: '50px', borderColor: palette.black }}
          align="center"
        >
          {specialistDecision(reciption.specialistDecision)}
        </TableCell>
        <TableCell
          style={{ width: '30px', borderColor: palette.black }}
          align="center"
        >
          <IconButton
            aria-label="delete"
            onClick={() => setShowPhone(!showPhone)}
          >
            {showPhone ? <AccountCircle /> : <CallIcon />}
          </IconButton>
        </TableCell>
        <TableCell
          style={{ width: '110px', borderColor: palette.black }}
          align="center"
        >
          {showPhone ? '+' + reciption.user.phone : reciption.user.fullName}
        </TableCell>
        <TableCell
          style={{ width: '110px', borderColor: palette.black }}
          align="center"
        >
          {reciption.patientConnected ? '+' : '-'}
        </TableCell>
        <TableCell
          style={{ width: '110px', borderColor: palette.black }}
          align="center"
        >
          {reciption.secondRecall ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>{`Второй звонок`}</span>
              <span>{`${moment(reciption.secondRecallDt).format(
                'DD.MM.YYYY HH:mm'
              )}`}</span>
            </div>
          ) : reciption.firstRecall ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>{`Первый звонок`}</span>
              <span>{`${moment(reciption.firstRecallDt).format(
                'DD.MM.YYYY HH:mm'
              )}`}</span>
            </div>
          ) : (
            'Не было'
          )}
        </TableCell>
        <TableCell
          style={{ width: '110px', borderColor: palette.black }}
          align="center"
        >
          {reciption.repeatedCall ? '+' : '-'}
        </TableCell>

        <TableCell
          style={{ width: '20px', borderColor: palette.black }}
          align="center"
        >
          <span style={{ fontSize: '1.2em' }}>
            {reciption.paymentType === 'reception' && '1️⃣ '}
            {reciption.user.isSigned ? '🟢' : '🔴'}{' '}
            {reciption.user.source !== 'current' && 'БФ '}
            {reciption.user.status === 'not_reliable'
              ? '🙁'
              : reciption.user.status === 'new'
                ? '🆕'
                : reciption.user.status === 'first'
                  ? '🤓'
                  : '😄'}
          </span>
        </TableCell>
        <TableCell
          style={{ width: '40px', borderColor: palette.black }}
          align="center"
        >
          {reciption.isReferraled ? (
            'Направлен'
          ) : (
            <span style={{ color: palette.status.failed }}>
              {reciption.refferal && reciption.refferal.length > 12
                ? reciption.refferal.substring(0, 12).trim() + '...'
                : reciption.refferal}
            </span>
          )}
        </TableCell>

        <TableCell
          style={{ width: '40px', borderColor: palette.black }}
          align="center"
        >
          <span
            style={{
              color: reciption.complaints ? palette.black : 'transparent'
            }}
            onClick={() =>
              reciption.complaints && setShowComplaints(!showComplaints)
            }
          >
            {reciption.complaints
              ? showComplaints
                ? reciption.complaints
                : reciption.complaints.substring(0, 8).trim() + '...'
              : ''}
          </span>
        </TableCell>
        <TableCell
          style={{ width: '30px', borderColor: palette.black }}
          align="center"
        >
          {medcardStatus(reciption)}
        </TableCell>

        <TableCell
          style={{ width: '40px', borderColor: palette.black }}
          align="center"
        >
          {reciption.moderatorName ? reciption.moderatorName : 'Не указано'}
        </TableCell>
        <TableCell
          style={{ width: '40px', borderColor: palette.black }}
          align="center"
        >
          {reciption.coordinatorName}
        </TableCell>
        <TableCell
          style={{ width: '30px', borderColor: palette.black }}
          align="center"
        >
          {reciption.adminMark}
        </TableCell>
        <TableCell
          style={{ width: '30px', borderColor: palette.black }}
          align="center"
        >
          {reciption.videoStatus === 'not_yet' ? (
            'Прием идет'
          ) : reciption.videoStatus === 'in_progress' ? (
            'В обработке'
          ) : (
            <Button
              text={'Скачать'}
              otherStyles={{
                background: 'none',
                boxShadow: 'none',
                margin: '0'
              }}
              onClick={() => handleDownload(reciption)}
            />
          )}
        </TableCell>
        <TableCell
          style={{ width: '70px', borderColor: palette.black }}
          align="center"
        >
          <MenuOptions
            openMedcard={openMedcard}
            openReviews={openReviews}
            openComplaints={openComplaints}
            openRefferal={openRefferal}
            openMark={openMark}
            openDeclineReception={openDeclineReception}
            reciption={reciption}
            openChangeTime={openChangeTime}
            openConnected={openConnected}
            openRepeated={openRepeated}
            openFirstRepeated={openFirstRepeated}
            openDecision={openDecision}
            openCoordinator={openCoordinator}
          />
        </TableCell>
      </TableRow>
    )
  })
}
const styles = () => ({})

export default withStyles(styles)(Reciptions)
